/* eslint-disable import/no-anonymous-default-export */

export default {
  MuiPickersModal: {
    dialogRoot: {
      "& .MuiDialogActions-root": {
        "& .MuiButtonBase-root": {
          backgroundColor: "#09133e !important",
          "&:hover": {
            backgroundColor: "#e3faee !important",
            opacity: 0.8,
          },
        },
      },
      minWidth: "480px",
      height: "420px",
      padding: 0,
      backgroundColor: "#fff",
      "& ::-webkit-scrollbar": {
        width: 0,
      },
    },
    dialog: {
      display: "flex",
      justifyContent: "center",
    },
    withAdditionalAction: {
      backgroundColor: "fff",
      color: "#72e5a7",
    },
  },

  MuiPickersDay: {
    daySelected: {
      backgroundColor: "rgba(0,255, 0, 0.3)",
    },
  },
  MuiPickersCalendarHeader: {
    iconButton: {
      backgroundColor: "#inherit",
    },
  },

  MuiPickersBasePicker: {
    container: {
      padding: 0,
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
};
